import Content from "../../components/home/ProductSearch";
import Hero from "../../components/home/Hero";
import Navbar from "../../components/shared/Navbar";
import LatestOffers from "../../components/home/LatestOffers";
import WhyBpr from "../../components/home/WhyBpr";
import InformationAndNews from "../../components/home/InformationAndNews";
import BriefInformation from "../../components/home/BriefInformation";
import SimulationCalculate from "../../components/home/SimulationCalculate";
import Footer from "../../components/shared/Footer";
import Map from "../../components/home/Map";
import RightBar from "../../components/shared/RightBar";
import { Helmet } from "react-helmet";
import SecurityInformation from "../../components/home/SecurityInformation";

export default function Home() {
    return (
        <div className="flex flex-col min-h-screen">
            <Helmet>
                <title>Home - BPR Palu Anugerah</title>
                <meta name="description" content="Selamat datang di halaman utama BPR Palu Anugerah. Jelajahi produk kami, penawaran terbaru, dan banyak lagi." />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Home - BPR Palu Anugerah" />
                <meta property="og:description" content="Selamat datang di halaman utama BPR Palu Anugerah. Jelajahi produk kami, penawaran terbaru, dan banyak lagi." />
                <meta property="og:type" content="website" />
            </Helmet>
            <Navbar />
            <RightBar></RightBar>
            <main className="flex-grow">
                <Hero />
                <Content></Content>
                <LatestOffers></LatestOffers>
                <WhyBpr></WhyBpr>
                <SecurityInformation></SecurityInformation>
                <InformationAndNews></InformationAndNews>
                <BriefInformation></BriefInformation>
                <SimulationCalculate></SimulationCalculate>
                <Map></Map>
            </main>
            <Footer />
        </div>
    )
}